import React from 'react';
import { Collapse, IconButton, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import classnames from 'classnames';

export default class Expandable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: props.expanded || false
    };
  }

  render() {
    const { children, title } = this.props;

    return (
      <React.Fragment>
        <div className="expandable-container" onClick={() => this.setState({expanded: !this.state.expanded})}>
          <Typography variant='body1' style={{display: 'inline-block', padding: '12px 0'}}><strong>{title}</strong></Typography>
          <IconButton className={classnames('button', {['open']: this.state.expanded})}>
            <ExpandMoreIcon style={{fontSize: '30px'}} />
          </IconButton>
        </div>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      </React.Fragment>
    );
  }
}
